module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAVCAYAAABCIB6VAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACcSURBVHgB7ZGhEQJBDEV/cifAUcKWAB0gGcDQAfLAMHSCA0kTzOCgBErYEpCIZT9Z1A2SW1D7ZpKfmCcSgTFfcxOJsQADdIDAPfKxPR/6vp42YUlyJ+hOclTScxYjtdUhKxymrhF6tPTIzPsCk4auRnD4Ekp1ae+nvUqO02K2std/iBU/ooiLuIiL+J/iW2v22cRPysLimoohpBkvatwouof0nDcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr-code-2.png
// module id = ifEb
// module chunks = 1